var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWizz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD815",
    d: "m29.611 15.584-2.597-2.598-2.598 2.598 2.598 2.597 2.597 2.597 2.597-2.597z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9813",
    d: "m29.611 0-2.598 2.597 2.598 2.598 2.597-2.598zM40 10.389l-2.597-2.597-2.598 2.597 2.598 2.598zM24.416 31.168l2.598 2.597 2.597-2.597-2.597-2.598zM6.235 12.986l2.598 2.598 2.597-2.598-2.597-2.597zM19.222 0l-2.598 2.597 2.598 2.598 2.597-2.598zM8.833 5.195l2.597 2.597 2.597-2.597-2.597-2.598zM37.403 18.181l-2.598 2.597 2.598 2.598L40 20.778zM32.208 28.57l2.597 2.598 2.598-2.598-2.598-2.597z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5B5B72",
    d: "m29.611 20.778-2.597-2.597-2.598 2.597-2.597-2.597-2.597-2.597 2.597-2.598-2.597-2.597-2.598-2.597-2.597 2.597 2.597 2.597-2.597 2.598 2.597 2.597-2.597 2.597-1.299-1.298-2.597 2.597 2.597 2.597-2.597 2.598-2.468 2.468-2.468 2.468-2.598 2.598L0 37.403 2.597 40l2.598-2.597 2.597-2.597 2.468-2.469.129-.129 2.339-2.339.129-.129 2.469-2.468 2.597 2.597 2.597-2.597-1.298-1.299 2.597-2.597 2.597 2.597 2.598-2.597 2.597 2.597 2.597-2.597z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9813",
    d: "m29.611 10.389-2.597-2.597-2.598 2.597-2.597-2.597-2.597 2.597 2.597 2.598-2.597 2.597 2.597 2.597 2.597 2.597 2.598-2.597-2.598-2.597 2.598-2.597 2.597 2.597 2.597-2.597z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWizz);
export default __webpack_public_path__ + "static/media/wizz.18e75788854ecbcede2f684d4109b062.svg";
export { ForwardRef as ReactComponent };